// extracted by mini-css-extract-plugin
export default {"container":"DLVEnZ","xs":"zhh_iJ","lg":"NW7FpB","imageContainer":"jwSPZO","image":"XFeGRp"};